import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useViewer } from "@/auth/shared";
import type { FileRouteTypes } from "@/routeTree.gen";

export function useRedirect(
  to: FileRouteTypes["to"],
  predicate: boolean | undefined,
) {
  const navigate = useNavigate();

  useEffect(() => {
    if (predicate === true) {
      navigate({
        replace: true,
        to,
      });
    }
  }, [predicate, navigate, to]);
}

export function useLoggedInRedirect(to: FileRouteTypes["to"]) {
  const viewer = useViewer();

  useRedirect(to, Boolean(viewer));
}

export function useNotLoggedInRedirect(to: FileRouteTypes["to"]) {
  const viewer = useViewer();

  useRedirect(to, viewer === null);
}
